import Payment from "./NewPayment";

export default Payment;
